import React,{useEffect,useState} from 'react';
import Media from '../pages/Media';
import '../pages/Quicklaunch.scss';
import style from '../pages/Quicklaunch.scss.json';
import {QuoraAdType,QuoraAdTypes} from 'titan-ads/lib/types';
import {Ad} from 'titan-ads/lib/shapes/TitanShapes';
import {AdSet} from 'titan-ads/lib/shapes/TitanShapes';

interface MediaUploaderProps
{
  mediaType: QuoraAdType[];
  media;
  onMediaReady;
  isQuickLaunched?: boolean;
  handleSubmit;
  handleMediaOptionChange: (
    index: number,
    value: QuoraAdType,
    bizName: string,
  ) => void;
  initBizName?: string;
}

export default function MediaUploader({
                                        mediaType,
                                        media,
                                        isQuickLaunched,
                                        onMediaReady,
                                        handleSubmit,
                                        handleMediaOptionChange,
                                        initBizName
                                      }: MediaUploaderProps) {
  const [businessName,setBusinessName] = useState('');
  const [adType,setAdType] = useState<QuoraAdType>('image_ad');
  return (
    <div className={style.mediaUploader}>
      <div className={style.mediaLoad}>
        <div className={style.formInput}>
          <h2>Business Name</h2>
          <input
            type="text"
            value={businessName || initBizName}
            onChange={(e) => setBusinessName(e.target.value)}
          />
        </div>
        <h2>Ad Type</h2>
        {mediaType.map((mediaOptions,index) => (
          <div key={index} className={style.formInput}>
            <div className={style.plusContent}></div>
            <select
              value={mediaType}
              onChange={(e) => {
                handleMediaOptionChange(
                  index,
                  e.target.value as QuoraAdType,
                  businessName,
                );
                setAdType(e.target.value as QuoraAdType);
              }}
            >
              <option value={QuoraAdTypes[0]}>Image Ad</option>
              <option value={QuoraAdTypes[1]}>Promote an answer</option>
              <option value={QuoraAdTypes[2]}>Text Ad</option>
              <option value={QuoraAdTypes[3]}>Video Ad</option>
            </select>
          </div>
        ))}
        {(adType === 'image_ad' || adType === 'video_ad') && (
          <>
            <Media
              onMediaReady={handleSubmit}
              mediaType={mediaType[0]}
              isQuickLaunched={true}
              isSelected={onMediaReady(media)}
            />
            <label className={style.labelSmall}>
              * to add a <strong>business logo</strong> as well as an image, select both a <strong>logo</strong> types
              and an <strong>image</strong> in Browse Media and press Insert Media.
            </label>
            <div className={style.mediaSelected}>
              {media.length > 0 && (
                <>
                  {media.map(
                    (mediaItem,index) => {
                      // skip if mediaItem is empty
                      if (!mediaItem || !mediaItem?.data) {
                        return null;
                      }
                      
                      const usageInfo = mediaItem.data.usageInfo || '';
                      const contentUrl = mediaItem.data.contentUrl || '';
                      const capitalizedUsageInfo = usageInfo.charAt(0).toUpperCase() + usageInfo.slice(1);

                      return (
                        <div key={index}>
                          {/*capitalized usage info as header*/}
                          <h5>{capitalizedUsageInfo}:</h5>
                          <div className={style.mediaAdset}>
                            {/*preview for logo and image for now*/}
                            {(usageInfo === 'logo' || usageInfo === 'image') ?
                              <img src={contentUrl} className={style[usageInfo]} width={'150'} /> : contentUrl.split('/').pop()}
                          </div>
                        </div>
                      );
                    },
                  )}
                </>
              )}
            </div>
          </>)}
      </div>
    </div>
  );
}
